import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {Document, Page, pdfjs} from "react-pdf";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import UploadJDFilesModal from "@pages/job/edit/UploadJDFilesModal";
import {requestDeleteJDFile, requestDownloadJDFile, requestGetJobDescriptionInfo} from "@app/services/JobService";

const JobFileContent = (props) => {
    const [job, setJob] = useState({input_job_descriptions: []});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [fetchingFiles, setFetchingFiles] = useState(false);
    const [currFileIndex, setCurrFileIndex] = useState(0);
    const [showUploadJDFilesModal, setShowUploadJDFilesModal] = useState(false);

    const {jobInput, onChange} = props

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const fetchJobDescriptions = (jobId) => {
        setFetchingFiles(true)
        requestGetJobDescriptionInfo({job_id: jobId}).then((res) => {
            if (res.content && res.content.length > 0) {
                job.input_job_descriptions = res.content
                setJob({...job})
                requestDownloadJDFile({job_description_id: job.input_job_descriptions[0].id}).then(url => {
                    job.input_job_descriptions[0].jd_display_url = url
                    setJob({...job})
                })
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình tải JD.`);
        }).finally(() => {
            setFetchingFiles(false)
        });
    };

    useEffect(() => {
        if (jobInput && jobInput.id) {
            // const inputJobDescriptions = [...job.input_job_descriptions]
            // const changeJob = {...jobInput}
            // changeJob.input_job_descriptions = inputJobDescriptions
            job.id = jobInput.id
            job.employer_id = jobInput.employer_id
            setJob({...job})

            if (jobInput.id) {
                fetchJobDescriptions(jobInput.id)
            }
        }

    }, [jobInput]);

    const processDownloadJDFile = (index) => {
        setFetchingFiles(true)
        if (!job.input_job_descriptions[index].jd_display_url) {
            requestDownloadJDFile({job_description_id: job.input_job_descriptions[index].id}).then(url => {
                job.input_job_descriptions[index].jd_display_url = url
                setJob({...job});
            }).finally(() => {
                setFetchingFiles(false)
            })
        }
    }

    const onJDNext = () => {
        let nextIndex = currFileIndex + 1;
        setCurrFileIndex(nextIndex);
        processDownloadJDFile(nextIndex)
    };

    const onJDBack = () => {
        let nextIndex = currFileIndex - 1;
        setCurrFileIndex(nextIndex);
        processDownloadJDFile(nextIndex)
    };

    const deleteJDFile = (id) => {
        requestDeleteJDFile({jd_id: id}).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Xóa JD thành công.`);
                job.input_job_descriptions.splice(currFileIndex, 1);
                setJob({...job})
                if (currFileIndex > job.input_job_descriptions.length - 1) {
                    onJDBack()
                } else {
                    processDownloadJDFile(currFileIndex)
                }
            } else {
                toast.error(`Xóa JD thất bại.`);
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xóa JD file.`);
        })
    };

    const onJDDelete = () => {
        let text = "Bạn chắc chắn muốn xóa JD?";
        if (window.confirm(text) === true) {
            deleteJDFile(job.input_job_descriptions[currFileIndex].id)
        }
    };

    const onLoadSuccess = async (pdfInfo, index) => {
        const jobDes = job.input_job_descriptions
        jobDes[index].numPages = [];
        for (let i = 1; i <= pdfInfo.numPages; i++) {
            jobDes[index].numPages.push(i);
        }
        setJob({...job});
    };

    const onOpenUploadFiles = () => {
        setShowUploadJDFilesModal(true)
    }

    const onCloseUploadFiles = (reload=false, changeJob) => {
        setShowUploadJDFilesModal(false)
        if (changeJob && changeJob.id) {
            job.id = changeJob.id
            job.input_job_descriptions = changeJob.input_job_descriptions
            setJob({...job})
            if (onChange) {
                onChange(job)
            }
        }
        if (reload) {
            fetchJobDescriptions(job.id)
        }

    }

    const showJDFilePageNumber = () => {
        if (job.input_job_descriptions
            && job.input_job_descriptions.length > 0
            && job.input_job_descriptions[currFileIndex]?.jd_file) {
            return `(${currFileIndex + 1} / ${job.input_job_descriptions.length})`
        }
        return ""
    }

    const openCurrentJDDisplayUrl = () => {
        if (job.input_job_descriptions && job.input_job_descriptions.length > 0) {
            window.open(
                job.input_job_descriptions[currFileIndex]?.jd_display_url,
                '_blank' // <- This is what makes it open in a new window.
            );
        }
    }

    const displayJDPages = () => {
        if (job.input_job_descriptions && job.input_job_descriptions.length > 0
            && job.input_job_descriptions[currFileIndex]
            && job.input_job_descriptions[currFileIndex].numPages) {
            return job.input_job_descriptions[currFileIndex].numPages.map(page =>
                (<Page pageNumber={page}
                    // width={500} height={800}
                       scale={1.5}
                />)
            )
        }
        return ""
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        JD files {showJDFilePageNumber()}
                    </h3>
                    <div className={'card-tools row'}>
                        <div className="btn-group mr-2">
                            <button type="button" className="btn btn-default">Actions</button>
                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                    data-toggle="dropdown">
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <div className="dropdown-menu" role="menu">

                                <button className='dropdown-item'
                                   type={"button"}
                                   disabled={job.input_job_descriptions.length === 0}
                                   onClick={() => openCurrentJDDisplayUrl()}>Download JD
                                </button>

                                {userLoginInfo.is_superuser &&
                                <button className='btn btn-info dropdown-item'
                                        rel="noreferrer"
                                        type='button' onClick={() => onOpenUploadFiles()}>Add JD
                                </button>
                                }
                                {userLoginInfo.is_superuser &&
                                <button className='dropdown-item' type={'button'}
                                        disabled={job.input_job_descriptions.length <= 1}
                                        onClick={() => onJDDelete()}>Xóa JD
                                </button>
                                }
                            </div>
                        </div>

                        <div className={'text-right'}>
                            <button className='btn' disabled={currFileIndex === 0} type={'button'}
                                    onClick={onJDBack}>
                                <i className='fas fa-arrow-left'/> Back
                            </button>
                        </div>
                        <div className={'text-right'}>
                            <button className='btn' disabled={currFileIndex >= job.input_job_descriptions.length - 1}
                                    type={'button'} onClick={onJDNext}>
                                <i className='fas fa-arrow-right'/> Next
                            </button>
                        </div>
                    </div>
                </div>
                <div className='card-body' style={{height: '83vh', overflow: 'auto', resize: 'both'}}>
                    <div>
                        <Document
                            file={job.input_job_descriptions[currFileIndex]?.jd_display_url}
                            onLoadSuccess={pdfInfo => onLoadSuccess(pdfInfo, currFileIndex)}
                        >
                            {displayJDPages()}
                        </Document>
                    </div>
                </div>
            </div>
            <UploadJDFilesModal isShow={showUploadJDFilesModal}
                                onClose={(reload, changeJob) => onCloseUploadFiles(reload, changeJob)}
                                jobInput={job}
            />
        </>
    )
}

export default JobFileContent;
